<script>
  import { notify } from "$lib/state/notify.js";
  /**@type {any}*/
  let notifyMessage;
  notify.subscribe((value) => (notifyMessage = value));
  let isActive = false;
  /**@type {number}*/
  let timer;
  $: {
    notifyMessage;
    if (notifyMessage.message !== null) {
      isActive = true;
    }
    if (isActive) {
      timer = setInterval(() => {
        isActive = false;
        notify.setNotify(null, false);
      }, 1_500);
    }
  }

  $: {
    isActive;
    if (!isActive) {
      clearInterval(timer);
    }
  }

</script>

<div
  class="message"
  class:active={isActive}
  class:green={notifyMessage.status}
  class:red={notifyMessage.status}
>
  {#if notifyMessage.message !== null}
    <p>{notifyMessage.message}</p>
  {/if}
</div>

<style>
  .message {
    position: fixed;
    top: calc(var(--header-height) + 80px);
    left: inherit;
    right: -250px;
    padding: 20px 30px;
    font-size: 1.2rem;
    color: #fdfdfd;
    border-radius: 60px 0 0 60px;
    text-transform: uppercase;
    font-family: "gotham-medium";
    letter-spacing: 0.5px;
    text-align: right;
    transition: all 500ms ease;
    opacity: 0;
  }
  .message.active {
    right: 0;
    opacity: 1;
  }
  .red {
    background-color: #f00;
  }
  .green {
    background-color: rgb(14, 141, 71);
  }

  @media (max-width: 767px) {
    .message {
      right: inherit;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 60px;
      font-size: 0.925rem;
      text-align: center;
      top: inherit;
      bottom: -50px;
      width: 95vw;
    }
    .message.active {
      bottom: 60px;
    }
  }
</style>
